// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + {"99":"LazyGoogleOneTap","873":"LazyIdentificationForm"}[chunkId] + "." + {"99":"5d01d30b23291057cd60","873":"d0a20fecf6880258907a"}[chunkId] + ".js";
};